module.exports = __webpack_public_path__ + "static/media/karl_straub_mood.4c7cefb4.jpg";